/**
 * Parse an OriginalFormatBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed OriginalFormatBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function frma(view) {
    return {
        dataFormat: view.readUint(4),
    };
}
;
//# sourceMappingURL=frma.js.map